import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input, Space, Popconfirm, Row, Col, Select, message } from 'antd';
import { useB2cStudentDetail } from 'hooks';
import { CheckOutlined } from '@ant-design/icons'
import { CompanySelectBox, CrmSelectBox } from 'components/atoms'
import { CompanyMatchModal, FileViewerModal, CrmEditModal, StudentDeleteModal, CrmMatchModal } from 'components/molecules';
import { usePopupManager } from 'react-popup-manager';
import { DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { isFileViewer } from 'utils/file-utils';
import axios from 'axios';
import { endpoints } from 'services';
import { SERVER_URL } from 'commons/constants';
import { fetcher } from 'services';
import { MSG } from 'commons/constants';
import { IMaskInput } from "react-imask";
import { makeMaskPhoneNumber } from "utils/form-utils"

export interface StudentEditModalProps extends PopupProps {
    id: number;  
    group: string;
    lectureInfo: LectureInfoDto;
}

const StudentEditModal = ({ 
    isOpen, 
    onClose, 
    id, group, lectureInfo}: StudentEditModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [memPrice, setMemPrice] = useState<number>(lectureInfo.lecture_price);
    const [salePrice, setSalePrice] = useState<number>(lectureInfo.lecture_price);
    const [routeOption, setRouteOption] = useState<any[]>(
        [
            {value:'HSG 마케팅 메일', label: 'HSG 마케팅 메일'},
            {value:'칼럼', label: '칼럼'},
            {value:'포털사이트검색', label: '포털사이트검색'},
            {value:'지인추천', label: '지인추천'},
            {value:'예전부터 HSG를 알고 있었음', label: '예전부터 HSG를 알고 있었음'},
            {value:'블로그/인스타/페북/유튜브', label: '블로그/인스타/페북/유튜브'},
            {value:'기타', label: '기타'},
        ]        
    )

  /* ======================================================
  * hooks
  * ====================================================== */
  const {studentInfo, studentInsert, studentUpdate, studentRestore, restoreSuccess, insertSuccess, updateSuccess } = useB2cStudentDetail(id, group);
  const [companySrl, setCompanySrl] = useState<number>(0);
  const [eduCrmSrl, setEduCrmSrl] = useState<number>(0);
  const [eduCrmName, setEduCrmName] = useState<string>('');
  const [companyName, setCompanyName] = useState<string>('');  
  const [orgCompanyName, setOrgCompanyName] = useState<string>(''); 
  const [companyInfo, setCompanyInfo] = useState<CompanyCodeListDto>();  
   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { open } = usePopupManager();  

   /* ======================================================
   * events
   * ====================================================== */
   const onSameStudent = () => {
    form.setFieldsValue({
        edu_name: form.getFieldValue('name_kor'),
        edu_phone: form.getFieldValue('phone'),
        edu_position: form.getFieldValue('position'),
        edu_email: form.getFieldValue('email'),
    });
}

    const onSameCrm = () => {
        form.setFieldsValue({
            acc_name: (eduCrmSrl > 0) ? eduCrmName : form.getFieldValue('edu_name'),
            acc_phone: form.getFieldValue('edu_phone'),
            acc_email: form.getFieldValue('edu_email'),
            acc_crm_srl: form.getFieldValue('edu_crm_srl'),
        });
    }

    const onDelete = (putoff: boolean) => {
        
        if (!!studentInfo) {
            open(StudentDeleteModal, {
                lectureInfo: lectureInfo,
                id: id,
                group: group,
                putoff: putoff,
                onClose: (isOk) => {
                  if (isOk) {
                    onClose?.(true);
                  };
                },
            });  
        }
    }

    const onRestore = () => {
        studentRestore({
            id: id,
        }) 
    }

    const onSubmit = (e) => {
        const sData = {
            id: id,
            b2c_group_srl: lectureInfo.id,
            app_srl: studentInfo?studentInfo.app_srl:0,
            company: (!!companySrl) ? orgCompanyName? orgCompanyName: companyName: e.company,
            company_srl: companySrl,
            sale_price: salePrice,
            student_cnt: studentInfo?studentInfo.student_cnt:1,
            name_kor: e.name_kor,
            name_eng: e.name_eng,
            department: e.department,
            position: e.position,
            mem_price: Number(form.getFieldValue('mem_price').toString().replaceAll(',','')),
            phone: e.phone,
            email: e.email,
            ebill_yn: e.ebill_yn,
            ebill_etc: e.ebill_etc,
            route: e.route,
            memo: e.memo,
            memo2: e.memo2,
            edu_crm_srl: eduCrmSrl,
            edu_name: e.edu_name?e.edu_name:eduCrmName,
            edu_position: e.edu_position,
            edu_email: e.edu_email,
            edu_phone: e.edu_phone,
            edu_phone2: e.edu_phone2,
            acc_name: e.acc_name,
            acc_phone: e.acc_phone,
            acc_email: e.acc_email,
        }  

        if (id > 0) {
            studentUpdate(sData);
        } else {
            studentInsert(sData);
        }

        if (!!studentInfo) {
 
        }
    };

    const onCloseClick = () => {
        onClose?.(studentInfo?.company_srl !== companySrl);
    }
    const onClickCompanyMatch = () => {
        if (studentInfo) {
            console.log(studentInfo);
            open(CompanyMatchModal, {
                company: studentInfo?.company,
                onClose: (isOk, company_srl, company_name) => {
                  if (isOk) {
                      setCompanySrl(company_srl);
                      setCompanyName(company_name);
      
                      fetcher.crm.postCrmAppCheck({
                          company_srl: company_srl,
                          edu_name: studentInfo.edu_name,
                          acc_name: studentInfo.acc_name
                      })
                      .then((res) => {
                          switch (res.code) {
                              case 200:
                                if (res.result && res.result.info) {
                                    setEduCrmSrl(res.result.info.edu_crm_srl);
                                }
                              break;
                              default:  
                                  message.error('검사중 오류 발생하였습니다.', 1);
                              break;
                          };
                      });  
                  };
                },
            }); 
        }
      }

      const onClickCrmMatch = (crm_srl: number, name: string, phone: string, email: string, position?: string, phone2?: string,) => {
        if (studentInfo) {
            open(CrmMatchModal, {
                company_srl: companySrl,
                company: companyName,
                crm_srl: crm_srl,
                name: name, 
                phone: phone, 
                phone2: phone2, 
                email: email, 
                position: position,
                onClose: (isOk, crm_srl, crm_name, org_name, org_phone, org_email, org_position, org_phone2) => {
                  if (isOk) {
                    setEduCrmSrl(crm_srl);
                    setEduCrmName(crm_name);
                    form.setFieldValue('edu_crm_srl', crm_srl);
                    form.setFieldValue('edu_name', org_name);
                    form.setFieldValue('edu_phone', org_phone);
                    form.setFieldValue('edu_email', org_email);
                    form.setFieldValue('edu_phone2', org_phone2);
                    form.setFieldValue('edu_position', org_position);
                  };
                },
            }); 
        }
      }

      const onOpenFileViewer = (fileId: number, fileName: string) => {
        open(FileViewerModal, {
          fileid: fileId,
          filename: fileName,
          onClose: (isOk) => {},
        });   
       }   

       const onDownload = (fileSeq:number, fileName: string): void => {
        axios({
          url: SERVER_URL + endpoints.file.download + '?file_id=' + fileSeq,
          method: 'get',
          responseType: 'blob',
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
          })
          .catch(() => {
            message.error('파일 다운로드 중 에러가 발생했습니다.', 1);
          });
        };

    const onCompanyBusinessUpdate = () => {
        if (!!companySrl && !!studentInfo?.business_file_id) {
            fetcher.company.postCompanyBusinessFileIdUpdate({
                id: companySrl,
                business_number_file_id: studentInfo.business_file_id,
            })
            .then((res) => {
                switch (res.code) {
                    case 200:
                        message.info('정보가 등록 되었습니다.', 1);
                    break;
                    default:  
                        message.error('등록중 오류 발생하였습니다.', 1);
                    break;
                };
            });   
        }
    }
  /* ======================================================
   * effects
   * ====================================================== */
    useEffect(() => {
        if (!!studentInfo) {   
            form.setFieldsValue({
                company: studentInfo.company, 
                company_srl: studentInfo.company_srl, 
                name_kor: studentInfo.name_kor, 
                name_eng: studentInfo.name_eng, 
                department: studentInfo.department, 
                position: studentInfo.position, 
                mem_price: studentInfo.mem_price, 
                phone: studentInfo.phone, 
                email: studentInfo.email, 
                ebill_yn: studentInfo.ebill_yn,
                ebill_etc: studentInfo.ebill_etc, 
                route: studentInfo.route, 
                memo: studentInfo.memo, 
                memo2: studentInfo.memo2, 
                edu_name: studentInfo.edu_name,
                edu_crm_srl: studentInfo.edu_crm_srl,
                edu_position: studentInfo.edu_position,
                edu_email: studentInfo.edu_email,
                edu_phone: studentInfo.edu_phone,
                edu_phone2: studentInfo.edu_phone2,
                acc_name: studentInfo.acc_name,
                acc_crm_srl: studentInfo.acc_crm_srl,
                acc_phone: studentInfo.acc_phone,
                acc_email: studentInfo.acc_email,
            });

            form.setFieldValue('mem_price', studentInfo.mem_price);

            setMemPrice(studentInfo.mem_price);
            setSalePrice(studentInfo.sale_price);
            setCompanySrl(studentInfo.company_srl);
            setCompanyName(studentInfo.company_match);
            setOrgCompanyName(studentInfo.company);
            setEduCrmSrl(studentInfo.edu_crm_srl);
            setEduCrmName(studentInfo.edu_name_match);

            if (!!studentInfo.route) {
                const routeIdx = routeOption.findIndex((opt) => opt.value === studentInfo.route)
                if (routeIdx < 0) setRouteOption([...routeOption, {value: studentInfo.route, label: studentInfo.route}])
            }
        }
    }, [studentInfo])

    useEffect(() => {
        form.setFieldsValue({
            mem_price: memPrice, 
        });
    }, [])

    useEffect(() => {
        if (insertSuccess || updateSuccess || restoreSuccess) {   
            onClose?.(true);
        }
    }, [insertSuccess, updateSuccess, restoreSuccess])

    return (
    <ModalWrapper open={isOpen} onCancel={onCloseClick} width={700} title={id===0?'교육생 등록':'교육생 수정'} closable>
        <Space direction='vertical' style={{width:'100%'}}>
            <h4 style={{marginBottom:'0px'}}>{lectureInfo.lecture_title}</h4>
            <label ><CheckOutlined /> 고객사</label>
            <Form
                form={form}
                name="StudentInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                {(id===0 || !!companySrl) ? (
                    <Form.Item name="company_srl" label={'고객사(기업명)'} rules={[{ required: true, message: '' }]}>
                        <CompanySelectBox required={true} form={form} company_srl={companySrl} onSelected={(value, option) => {setCompanySrl(Number(value)); setCompanyName(option.label); setCompanyInfo(option)}} />
                        <Form.Item style={{ width:'150px', display: 'inline-block', marginLeft: '10px' }}>
                            <label>{studentInfo?.company}</label>
                        </Form.Item>                        
                    </Form.Item>  
                ): (
                    <Form.Item name="company" label={'고객사명(기업명)'} rules={[{ required: true, message: '' }]}>      
                        <Form.Item name={'company'} style={{ width:'150px', display: 'inline-block', marginRight: '10px' }}>
                            <Input type="text" placeholder='' onChange={(e) => {                        
                                const pattern = /[a-z0-9]|[ \[\]{}()<>?|`~!@#$%^&*-_+=,.;:\"'\\]/g;
                                form.setFieldValue('company', e.target.value.replace(pattern, ''));
                            }}/>                   
                        </Form.Item> 
                        <Button type="primary" onClick={onClickCompanyMatch}>고객사 매칭</Button>
                    </Form.Item>                    
                )}
                <Row>
                    <Col span={12}>
                    <Form.Item label={'신청인원'}>
                        <label>{studentInfo?studentInfo.student_cnt:1}명</label>                  
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item label={'총교육비 (vat포함)'}>
                        <label>{salePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ({(salePrice*1.1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")})</label>                  
                    </Form.Item>   
                    </Col>            
                </Row>
                <Form.Item label={'사업자등록증'}>
                    {(!!studentInfo) && ((!!companyInfo && !!companySrl && companySrl > 0)?
                    (studentInfo.business_file_id)?
                    (companyInfo && studentInfo.business_file_id === companyInfo.business_number_file_id)?
                    ( // 등록된 파일이 이미 회사에 등록된경우
                    <Space>
                        <Button onClick={()=>{onDownload && onDownload(studentInfo.business_file_id, studentInfo.business_file_name)}} shape="round" icon={<DownloadOutlined />} size='small' style={{padding:'0px 5px'}}/>
                        {isFileViewer(studentInfo.business_file_name) && (<Button onClick={()=>{onOpenFileViewer(studentInfo.business_file_id, studentInfo.business_file_name)}} shape="round" icon={<SearchOutlined />} size='small' style={{padding:'0px 5px'}}/>)}                                   
                    </Space>               
                    ):( // 등록된 업체 이지만 기존 등록된 파일과 다를 경우
                    <Space>
                        <Button onClick={()=>{onDownload && onDownload(studentInfo.business_file_id, studentInfo.business_file_name)}} shape="round" icon={<DownloadOutlined />} size='small' style={{padding:'0px 5px'}}/>
                        {isFileViewer(studentInfo.business_file_name) && (<Button onClick={()=>{onOpenFileViewer(studentInfo.business_file_id, studentInfo.business_file_name)}} shape="round" icon={<SearchOutlined />} size='small' style={{padding:'0px 5px'}}/>)}                                   
                        <Button onClick={onCompanyBusinessUpdate}>기존 고객사에 반영</Button>
                    </Space>  
                    ):(!!companyInfo.business_number_file_id)?( // 등록된 업체 이지만 기존 업로드된 사업자 등록증이 없을경우
                    <Space>
                        <Button onClick={()=>{onDownload && onDownload(companyInfo.business_number_file_id, companyInfo.business_number_file_name)}} shape="round" icon={<DownloadOutlined />} size='small' style={{padding:'0px 5px'}}/>
                        {isFileViewer(companyInfo.business_number_file_name) && (<Button onClick={()=>{onOpenFileViewer(companyInfo.business_number_file_id, companyInfo.business_number_file_name)}} shape="round" icon={<SearchOutlined />} size='small' style={{padding:'0px 5px'}}/>)}                                   
                    </Space>               
                    ):(
                    <label>사업자 등록증을 업로드 하지 않았습니다.</label>
                    ):(!!studentInfo.business_file_name)?( // 등록된 업체가 아닐 경우
                    <Space>
                        <Button onClick={()=>{onDownload && onDownload(studentInfo.business_file_id, studentInfo.business_file_name)}} shape="round" icon={<DownloadOutlined />} size='small' style={{padding:'0px 5px'}}/>
                        {isFileViewer(studentInfo.business_file_name) && (<Button onClick={()=>{onOpenFileViewer(studentInfo.business_file_id, studentInfo.business_file_name)}} shape="round" icon={<SearchOutlined />} size='small' style={{padding:'0px 5px'}}/>)}                                                           
                    </Space>               
                    ):(<label>사업자 등록증을 업로드 하지 않았습니다.</label>))}
                    
                </Form.Item> 
            </Form>
            <label ><CheckOutlined /> 교육생</label>
            <Form
                form={form}
                name="StudentInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Row>
                    <Col span={12}>
                    <Form.Item name={'name_kor'} label={'이름'} rules={[{ required: true, message: '' }]}>
                        <Input type="text" placeholder='' />                 
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item name={'name_eng'} label={'영문명'}>
                        <Input type="text" placeholder='' />                 
                    </Form.Item>   
                    </Col>            
                </Row>
                <Row>
                    <Col span={12}>
                    <Form.Item name={'department'} label={'부서'} rules={[{ required: true, message: '' }]}>
                        <Input type="text" placeholder='' />                 
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item name={'position'} label={'직급'} rules={[{ required: true, message: '' }]}>
                        <Input type="text" placeholder='' />                 
                    </Form.Item>   
                    </Col>            
                </Row>
                <Form.Item name={'mem_price'} label={'교육비 (vat포함)'} rules={[{ required: true, message: '' }]}>
                    <Form.Item name={'mem_price'} style={{ width:'100px', display: 'inline-block', marginRight: '5px' }} rules={[{ required: true, message: '' }]}>
                    <IMaskInput 
                        min={0} 
                        mask = {Number}
                        thousandsSeparator={','}
                        defaultValue={memPrice}
                        className={'ant-input'} 
                        unmask={'typed'} 
                        onAccept = {((value, mask) => {
                            form.setFieldValue('mem_price', value),
                            setMemPrice(Number(value));
                            if (studentInfo) {
                                setSalePrice(studentInfo.sale_price - studentInfo.mem_price + Number(value)); 
                            } else 
                                setSalePrice(Number(value));
                        })}/>       
                    </Form.Item> 
                    <Form.Item  style={{ display: 'inline-block'}}>
                        <label>({(memPrice*1.1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")})</label>                
                    </Form.Item>                 
                </Form.Item>
                <Row>
                    <Col span={12}>
                    <Form.Item name={'phone'} label={'핸드폰'} rules={[{ required: true, message: '' }]}>
                        <IMaskInput mask={'000-0000-0000'} className={'ant-input'} placeholder='핸드폰번호를 입력하세요'/>                
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item name={'email'} label={'이메일'} rules={[{ required: true, message: '' }]}>
                        <Input type="text" placeholder='' />                 
                    </Form.Item>   
                    </Col>            
                </Row>
                <Form.Item name={'ebill_yn'} label={'결제방법'} rules={[{ required: true, message: '' }]}>
                    <Form.Item name={'ebill_yn'} style={{ width:'150px', display: 'inline-block', marginRight: '5px' }}>
                        <Select 
                            placeholder="결제방법 선택" 
                            style={{width:"150px"}}
                            options={[
                                {value:'Y', label: '세금계산서 발행'},
                                {value:'N', label: '온라인 카드결제'},
                                {value:'E', label: '기타'},
                            ]} />                   
                    </Form.Item> 
                    <Form.Item name={'ebill_etc'} style={{ width:'calc(100% - 150px - 10px)', display: 'inline-block', marginRight: '5px' }}>
                        <Input type="text" placeholder='발행일자' />                 
                    </Form.Item> 
                </Form.Item>

 
                <Form.Item name={'route'} label={'신청경로'}>
                    <Select 
                            placeholder="신청경로 선택" 
                            options={routeOption} />               
                </Form.Item>   
                <Form.Item name='memo' label={'메모'}>
                    <TextArea rows={2} placeholder='메모를 입력하세요'/>   
                </Form.Item>      
                <Form.Item name='memo2' label={'교육이력'}>
                    <TextArea rows={2} placeholder='교육이력을 입력하세요'/>   
                </Form.Item>                          
            </Form>  
            <Space><label ><CheckOutlined /> 교육담당자</label><Button size='small' onClick={onSameStudent}>교육생과 동일</Button></Space>
            <Form
                form={form}
                name="StudentInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                {(id===0 || !!eduCrmSrl) ? (
                <Form.Item name="edu_crm_srl" label={'이름'} rules={[{ required: true, message: '' }]}>
                    <CrmSelectBox 
                        form={form} 
                        company={companySrl} 
                        company_name={companyName} 
                        field_name={'edu_crm_srl'}
                        required={true}
                        addCrm={{
                            id:0,
                            name: form.getFieldValue("edu_name"),
                            phone: form.getFieldValue('edu_phone'),
                            tel: form.getFieldValue('edu_phone2'),                            
                            email: form.getFieldValue('edu_email'),
                            position: form.getFieldValue('edu_position'),
                        }}                        
                        onSelected={(value, option) => {
                            setEduCrmSrl(Number(value)); 
                            setEduCrmName(option.label);
                            if (id===0) {
                                form.setFieldValue("edu_email", option.email);
                                form.setFieldValue("edu_phone", option.phone);
                                form.setFieldValue("edu_phone2", option.tel);
                                form.setFieldValue("edu_position", option.position);                                
                            }
                        }}
                    />   
                    {(!!companySrl) && (
                        <Button 
                            type="primary" 
                            style={{marginLeft:'5px'}}
                            onClick={()=>onClickCrmMatch(
                                eduCrmSrl,
                                form.getFieldValue('edu_name'),
                                form.getFieldValue('edu_phone'),
                                form.getFieldValue('edu_email'),
                                form.getFieldValue('edu_position'),
                                form.getFieldValue('edu_phone2')
                            )}
                        >CRM 매칭</Button>                        
                    )}  
                    <Form.Item name="edu_name" noStyle={true}>    
                        <Input type="text" placeholder='' hidden={true} />
                    </Form.Item>                                                           
                </Form.Item>                     
                ): (
                <Form.Item name="edu_name" label={'이름'} rules={[{ required: true, message: '' }]}>    
                    <Form.Item name={'edu_name'} style={{ width:'150px', display: 'inline-block', marginRight: '10px' }}>
                        <Input type="text" placeholder=''/>                      
                    </Form.Item> 
                    {(!!companySrl) && (
                        <Button 
                            type="primary" 
                            onClick={()=>onClickCrmMatch(
                                eduCrmSrl,
                                form.getFieldValue('edu_name'),
                                form.getFieldValue('edu_phone'),
                                form.getFieldValue('edu_email'),
                                form.getFieldValue('edu_position'),
                                form.getFieldValue('edu_phone2')
                            )}
                        >CRM 매칭</Button>
                    )}
                </Form.Item>                    
                )}
                <Row>
                    <Col span={12}>
                    <Form.Item name="edu_position" label={'직급'}>
                        <Input type="text" placeholder=''/>                 
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item name="edu_email" label={'이메일'}>
                        <Input type="text" placeholder=''/>                 
                    </Form.Item>   
                    </Col>            
                </Row>
                <Row>
                    <Col span={12}>
                    <Form.Item name="edu_phone" label={'핸드폰'}>
                        <IMaskInput mask={'000-0000-0000'} className={'ant-input'} placeholder='핸드폰번호를 입력하세요'/>                
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item name="edu_phone2" label={'유선전화'}>
                    <Input placeholder='전화번호를 입력하세요' onChange={(e) => form.setFieldValue('edu_phone2', makeMaskPhoneNumber(e.target.value))} />  
                    </Form.Item>   
                    </Col>            
                </Row>
            </Form>
            <Space><label ><CheckOutlined /> 결제담당자</label><Button size='small' onClick={onSameCrm}>교육담당자와 동일</Button></Space>
            <Form
                form={form}
                name="StudentInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item name="acc_name" label={'이름'} rules={[{ required: true, message: '' }]}>    
                    <Form.Item name={'acc_name'} style={{ width:'150px', display: 'inline-block', marginRight: '10px' }}>
                        <Input type="text" placeholder=''/>                      
                    </Form.Item> 
                </Form.Item>                    
                <Row>
                    <Col span={12}>
                    <Form.Item name="acc_phone" label={'핸드폰'}>
                        <IMaskInput mask={'000-0000-0000'} className={'ant-input'} placeholder='핸드폰번호를 입력하세요'/>                 
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item name="acc_email" label={'이메일'}>
                        <Input type="text" placeholder=''/>                 
                    </Form.Item>   
                    </Col>            
                </Row>
                <ButtonGroup className={'buttonsWrapper'}>
                    <div>
                        <Button onClick={onCloseClick} style={{marginRight: "5px"}}>닫기</Button>
                        {(!!studentInfo && studentInfo.status_type == 'AV') && (<Button onClick={()=>onDelete(true)} style={{marginRight: "5px", width:'80px'}}>일정연기</Button>)}
                        {(!!studentInfo && studentInfo.status_type == 'AV') && (<Button onClick={()=>onDelete(false)} style={{marginRight: "5px", width:'80px'}}>일정취소</Button>)}                        
                        {(!!studentInfo && studentInfo.status_type != 'AV') && (
                            <Popconfirm
                                title="일정을 복원 하시겠습니까?"
                                okText="복원"
                                cancelText="취소"
                                onConfirm={() => onRestore()}
                            >   
                                <Button style={{marginRight: "5px", width:'80px'}} >일정복원</Button>
                            </Popconfirm>                   
                        )}                        
                    </div>
                    <div>
                        <Button  htmlType="submit" type="primary">{id===0?'등록':'수정'}</Button>
                    </div>                      
                </ButtonGroup> 
            </Form>
        </Space>        
    </ModalWrapper>  
    )    
};

export default React.memo(StudentEditModal);    